import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
// Migrated 1:1 from @nexato/nx-core-module (issue/components/assign/assign-issue-widget.component.ts, #683)
import { EditSelectable, EditSelectInputComponent } from '../../edit-select-form-control/edit-select-form-control.component';
import { Issue } from '../../../entities/issue/issue';
import { CommandService } from '../../../services/command/command.service';
import { CommandInput, CommandTemplate } from '../../../entities/commandTemplate/commandTemplate';
import { User } from '../../../entities/user/user';
import { IssueWidget } from '../../../services/issue/issue-widget.interface';
import { WidgetCoordinatorService } from '../../../services/issue/widget-coordinator.service';
import { RefetchCoordinator } from '../../../services/refetch-coordinator/refetch-coordinator.service';

@Component({
  selector: 'nx-assign-issue-widget',
  templateUrl: './assign-issue-widget.component.html',
})
export class AssignIssueWidgetComponent implements OnDestroy, OnInit, OnChanges, IssueWidget {

  @Input() issue: Issue;
  @ViewChild('selectComponent') selectComponent: EditSelectInputComponent;

  public editMode: boolean = false;
  public isLoading: boolean = false;

  public commandTemplate: CommandTemplate;

  selectedControl = new FormControl<User | null>(null);
  form = new FormGroup({
    selected: this.selectedControl
  });

  candidates: User[] = undefined;
  assignee: User = undefined;

  private widgetId = `assign-widget-${Math.random().toString(36).substr(2, 9)}`;
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private refetchCoordinator = inject(RefetchCoordinator);
  private unregisterRefetch?: () => void;

  constructor(
    private commandService: CommandService,
    private coordinator: WidgetCoordinatorService
  ) {
  }


  ngOnInit(): void {
    // Register with RefetchCoordinator as detail view
    if (this.issue?.id) {
      this.unregisterRefetch = this.refetchCoordinator.register(
        this,
        this.issue.getEntityType(),
        this.issue.id
      );
    }

    // Subscribe to cancel all requests
    this.coordinator.cancelAll$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(exceptId => {
        if (exceptId !== this.widgetId) {
          this.cancel();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['issue'] && this.issue && this.issue.id) {
      this.loadCommandTemaplate();
    }
  }

  loadCommandTemaplate() {
    const commandInput = new CommandInput();
    commandInput.name = "issueAssignCommand";
    commandInput.addParameter('commandProviderId', this.issue.id);

    this.commandService.getCommandByCommandInput(commandInput)
        .pipe(take(1))
        .subscribe(result => {
          this.commandTemplate = result.data.getCommandByCommandInput;
          this.candidates = User.createUsers(this.commandTemplate?.flow?.settings?.customFlowSettings?.candidates);
          if(this.commandTemplate?.flow?.settings?.customFlowSettings?.assignee){
            this.assignee = new User(this.commandTemplate?.flow?.settings?.customFlowSettings?.assignee);
          } else {
            this.assignee = undefined;
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        });
  }

  ngOnDestroy(): void {
    this.unregisterRefetch?.();
  }

  edit() {
    this.coordinator.requestCancelAll(this.widgetId);
    this.editMode = true;
    if (this.assignee) {
      this.selectedControl.setValue(this.assignee);
    }
    setTimeout(() => {
      this.selectComponent?.openAndFocusFilter();
    }, 10);
  }

  save() {
    this.editMode = false;
    // if (this.assignee && this.assignee.id === this.selectedControl?.value?.id) {
    //   console.log('No change in status');
    //   return;
    // }
    let commandInput = new CommandInput();
    commandInput.name = this.commandTemplate.name;
    commandInput.addParameter('commandProviderId', this.issue.id);
    commandInput.addParameter('assigneeId', this.selectedControl.value?.id);
    this.isLoading = true;
    this.commandService.sendCommand(commandInput, (result) => {
      this.loadCommandTemaplate();
      this.refetchCoordinator.emit({ entityType: this.issue.getEntityType(), entityId: this.issue.id });
    });
  }

  cancel() {
    this.editMode = false;
  }

  reload(): void {
    this.loadCommandTemaplate();
  }

}
